import moment from 'moment';
import { IdataSource, Ipagination } from '@/utils';
import { SubOrderStatus } from '@/config';
import actionType from '../actions/transaction/actionType';

interface IfrontState {
  amount: number; // 金额
  createBy: string;
  customDetail: string; // 消费详情
  name: string;
  no: string;
  orderNo: string;
  payDetail: string; // 支付详情
  paymentTime: string; // 支付时间
  paymentType: string;
  subjectCode: string;
  subjectName: string; // 账务项目名称
}

export interface IrefundItem {
  billNo: string;
  name: string; // 付款人
  payAmount: number; // 付款金额
  paymentNo: string; // 流水号
  paymentType: string; // 支付渠道
  phoneNo: string; // 手机号
  reason: string; // 成功或失败原因
  refundAmount: number; // 退款金额
  refundBillItemNo: string; // 退款账目编号
  roomNo: string;
  status: number; // 1成功，2强制成功、3失败
  subjectCode: string; // 账务编码
  subjectName: string; // 账务名称
  updateTime: string; // 退款时间
  resvNo: string;
  wyuid: string;
  subOrderStatus: SubOrderStatus;
  createTime?: any;
  paymentTime?: any;
}

export interface TransactionState extends Ipagination {
  consumptionItemList: Array<IdataSource>;
  frontConsumeList: Array<IfrontState>;
  payOrderNo: string;
  refundList: Array<IrefundItem>;
  refundPageLoading: boolean;
  consumerAtTheFrontDeskLoading: boolean;
  timeInterval: any;

  orderInfoList: any; // 账务明细
  crossNightRefundInfoList: any; // 跨夜审退款单
  getOrderDetailLoading: boolean;

  amount: number; // 商品可退款金额
  count: number; // 商品总数
  currentAmount: number; // 退货后的 商品可退款金额
  currentCount: number; // 退货后的 商品总数
  frontGoods: any[]; // 商品明细
  getGoodsDetailLoading: boolean;
}

const getInitalTime = () => {
  return [moment(new Date()).subtract(30, 'days'), moment(new Date())];
};

const initialState: TransactionState = {
  // 列表
  consumptionItemList: [],
  frontConsumeList: [],
  payOrderNo: '',
  refundList: [],
  refundPageLoading: false,
  consumerAtTheFrontDeskLoading: false,
  pageSize: 50,
  pageNum: 1,
  total: 0,
  timeInterval: getInitalTime(),

  // 订单详情
  orderInfoList: [],
  crossNightRefundInfoList: [],
  getOrderDetailLoading: false,

  // 退货退款
  amount: 0,
  count: 0,
  currentAmount: 0,
  currentCount: 0,
  frontGoods: [],
  getGoodsDetailLoading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionType.CLEAR_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.SAVE_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.SET_PAGINATION:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.SET_TIME:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.RESET:
      return {
        ...state,
        ...action.payload,
        pageNum: 1,
        pageSize: 50,
        total: 0,
      };
    case actionType.GET_ORDER_DETAIL:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.GET_GOODS_DETAIL:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.SET_GOODS_DETAIL:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.TOGGLE_LOADING: {
      const loading = state[action.payload];
      return {
        ...state,
        [action.payload]: !loading,
      };
    }

    case actionType.RESET_PAGINATION:
      return {
        ...state,
        pageNum: 1,
        pageSize: 50,
        total: 0,
      };
    case actionType.COMSUMPTION_ITEM_LIST:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.FRONT_CONSUME:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.FRONT_CONSUME_LIST:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.UPDATE_FRONT_CONSUME:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.REFUND_PAGE:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
